exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-dark{background-color:#58595b}.background-orange{background-color:#f05323}\n", ""]);

// exports
